<template>
  <div>
    <section>
      <h2 v-if="!fairWall._id">Neue Interessante Messe erfassen</h2>
      <h2 v-if="fairWall._id">Interessante Messe bearbeiten</h2>
      <div class="o-grid o-grid--no-gutter">
        <div class="o-grid__cell top-buttons">
          <bos-button @click="saveFairWall">Messe speichern</bos-button>
        </div>
      </div>
    </section>
    <section>
      <div class="o-grid o-grid--no-gutter">
        <div class="o-grid__cell o-grid__cell--width-100">
          <bos-input
            v-model="fairWall.displayName"
            key="displayName"
            :error="errors.displayName"
            label="Bezeichnung:"
            :required="true"
          />
          <image-uploader
            :debug="1"
            :maxWidth="400"
            :quality="0.7"
            :autoRotate="true"
            outputFormat="verbose"
            :preview="false"
            :className="['fileinput', { error: this.errors.logoDe.hasError }]"
            capture="environment"
            accept="video/*,image/*"
            doNotResize="['gif', 'svg']"
            @input="setLogoDe"
            id="logo"
          >
            <label for="logoDe" slot="upload-label">Logo Messe De:</label>
          </image-uploader>
          <div v-if="fairWall.logoDe">
            <img v-bind:src="fairWall.logoDe" /><br />
            <a @click="clearImage" data-image="logoDe">Bild entfernen</a><br />
            <br />
          </div>
          <image-uploader
            :debug="1"
            :maxWidth="400"
            :quality="0.7"
            :autoRotate="true"
            outputFormat="verbose"
            :preview="false"
            :className="['fileinput', { error: this.errors.logoFr.hasError }]"
            capture="environment"
            accept="video/*,image/*"
            doNotResize="['gif', 'svg']"
            @input="setLogoFr"
            id="logo"
          >
            <label for="logoFr" slot="upload-label">Logo Messe Fr:</label>
          </image-uploader>
          <div v-if="fairWall.logoFr">
            <img v-bind:src="fairWall.logoFr" /><br />
            <a @click="clearImage" data-image="logoFr">Bild entfernen</a><br />
            <br />
          </div>
          <image-uploader
            :debug="1"
            :maxWidth="400"
            :quality="0.7"
            :autoRotate="true"
            outputFormat="verbose"
            :preview="false"
            :className="['fileinput', { error: this.errors.logoEn.hasError }]"
            capture="environment"
            accept="video/*,image/*"
            doNotResize="['gif', 'svg']"
            @input="setLogoEn"
            id="logo"
          >
            <label for="logoEn" slot="upload-label">Logo Messe En:</label>
          </image-uploader>
          <div v-if="fairWall.logoEn">
            <img v-bind:src="fairWall.logoEn" /><br />
            <a @click="clearImage" data-image="logoEn">Bild entfernen</a><br />
            <br />
          </div>
          <bos-input
            v-model="fairWall.urlDe"
            key="urlDe"
            :error="errors.urlDe"
            label="CTA - Link (de):"
          />
          <bos-input
            v-model="fairWall.urlFr"
            key="urlFr"
            :error="errors.urlFr"
            label="CTA - Link (fr):"
          />
          <bos-input
            v-model="fairWall.urlEn"
            key="urlEn"
            :error="errors.urlEn"
            label="CTA - Link (en):"
          />
          <bos-input
            v-model="fairWall.publish"
            key="publish"
            :error="errors.publish"
            label="Publikation (von/bis):"
            :required="true"
            type="daterange"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import BosButton from '@/components/BosButton'
import BosInput from '@/components/BosInput'
import ApiService from '@/services/ApiService'
import FormValidator from '@/services/FormValidator'

export default {
  name: 'AdminAdvertisingFairWallCreate',
  components: {
    //BosDocumentEntry,
    BosInput,
    BosButton
  },
  props: {
    msg: String
  },
  data() {
    return {
      fairWall: {
        logo: null,
        logoDe: null,
        logoFr: null,
        logoEn: null
      },
      errors: {
        displayName: {
          hasError: false
        },
        logo: {
          hasError: false
        },
        logoDe: {
          hasError: false
        },
        logoFr: {
          hasError: false
        },
        logoEn: {
          hasError: false
        },
        urlDe: {
          hasError: false
        },
        urlFr: {
          hasError: false
        },
        urlEn: {
          hasError: false
        },
        publish: {
          hasError: false
        }
      },
      flowStep: {}
    }
  },
  methods: {
    setFairSeries(options) {
      ApiService.getFairSeries().then(response => {
        while (options.length > 0) {
          options.pop()
        }
        options.push({
          value: '',
          text: '-'
        })
        for (var i = 0; i < response.data.length; i++) {
          options.push({
            value: response.data[i]._id,
            text: response.data[i].titleDe
          })
        }
      })
    },
    setEditStep(task) {
      this.editStep = task
    },
    reopenStep(step) {
      //this.editStep = step
      console.log(step)
    },
    updateStep() {
      this.fairWall.steps.push(this.$refs.stepForm.value)
      this.flowStep = {}
    },
    updateDoc() {
      this.fairWall.documents.push(this.$refs.docForm.value)
      this.editDoc = {}
    },
    tabClicked() {
      return
    },
    tabChanged() {
      return
    },
    clearImage(e) {
      this.fairWall[e.currentTarget.getAttribute('data-image')] = null
    },
    getValidateFairWall() {
      //rules
      return [
        {
          value: this.fairWall.displayName,
          required: true,
          errorKey: 'displayName'
        },
        {
          value: this.fairWall.urlDe,
          errorKey: 'urlDe'
        },
        {
          value: this.fairWall.urlFr,
          errorKey: 'urlFr'
        },
        {
          value: this.fairWall.urlEn,
          errorKey: 'urlEn'
        },
        {
          value: this.fairWall.logoDe,
          errorKey: 'logoDe'
        },
        {
          value: this.fairWall.logoFr,
          errorKey: 'logoFr'
        },
        {
          value: this.fairWall.logoEn,
          errorKey: 'logoEn'
        },
        {
          value: this.fairWall.publish,
          required: true,
          errorKey: 'publish',
          type: 'daterange'
        }
      ]
    },
    saveFairWall() {
      FormValidator.validateForm(this.getValidateFairWall(), this.errors).then(
        () => {
          let action = this.$route.params.id
            ? 'updateFairWallEntry'
            : 'createFairWallEntry'
          let allowedStates = [200, 201]

          ApiService[action](this.fairWall).then(
            result => {
              if (allowedStates.includes(result.status)) {
                this.$router.push({ name: 'AdminAdvertisingFairWallOverview' })
              }
            },
            error => {
              console.warn(error)
            }
          )
        }
      )
    },
    addInfotext() {
      this.editStep.infoTexts.push({})
    },
    removeInfoText(idx) {
      console.info('Remove item at: ' + idx.toString())
      this.editStep.infoTexts.splice(idx, 1)
    },
    setLogoDe(file) {
      this.fairWall.logoDe = file.dataUrl
    },
    setLogoFr(file) {
      this.fairWall.logoFr = file.dataUrl
    },
    setLogoEn(file) {
      this.fairWall.logoEn = file.dataUrl
    }
  },
  mounted() {
    if (this.$route.params.id) {
      ApiService.getFairWallEntry(this.$route.params.id).then(res => {
        this.fairWall = res.data

        if (
          this.fairWall.logoDe === undefined &&
          this.fairWall.logo !== undefined &&
          this.fairWall.logo !== null
        ) {
          this.fairWall.logoDe = this.fairWall.logo
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/assets/css/variables.scss';

.list-group-item {
  padding: 0.333rem 0;
  vertical-align: center;
  display: block;

  &:nth-child(even) {
    background-color: #f7f6f3;
  }
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.bos-timeflow {
  text-align: center;
  list-style: none;
  display: inline-table;
  margin: 0 0 4rem 0;

  li {
    display: inline;
    margin: 0;

    span {
      display: block;
      float: left;
      height: 44px;
      background: rgba(104, 115, 116, 0.3);
      text-align: center;
      padding: 14px 10px 0 30px;
      position: relative;
      margin: 0 4px 0 0;

      font-size: $timeflow-font-size;
      text-decoration: none;
      color: #fff;

      &:after {
        content: '';
        border-top: 22px solid transparent;
        border-bottom: 22px solid transparent;
        border-left: 20px solid rgba(104, 115, 116, 0.3);
        position: absolute;
        right: -20px;
        top: 0;
        z-index: 1;
      }

      &:before {
        content: '';
        border-top: 22px solid transparent;
        border-bottom: 22px solid transparent;
        border-left: 20px solid #fff;
        position: absolute;
        left: 0;
        top: 0;
      }
    }

    &:first-child span {
      padding-left: 24px;

      &:before {
        display: none;
      }
    }

    &:last-child span {
      padding-right: 20px;

      &:after {
        display: none;
      }
    }

    &.active span {
      background: rgba(46, 150, 153, 0.7);

      &:after {
        border-left-color: rgba(46, 150, 153, 0.7);
      }
    }
  }
}

.top-buttons {
  float: right;
  text-align: right;

  button {
    margin-right: 1.333rem;

    &:last-of-type {
      margin-right: 0;
    }
  }
}

hr {
  margin: 1.333rem 0 4rem 0;
  border: none;
  border-bottom: 1px solid #c9c9c9;
}

.empty {
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  padding: 0.333rem;
  &:after {
    display: block;
    width: 100%;
    content: 'hierher ziehen';
    text-align: center;
    color: rgba(0, 0, 0, 0.3);
  }
}

input.fileinput.error + label {
  color: red;
}
</style>
